import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { JobView } from './features/job/JobView';
import { SlaView } from './features/sla/SlaView';
import { ReportsView } from './features/reports/ReportsView';
import { SlaExpendedView } from "./features/reports/SlaExpendedView";
import { CustomBusinessVolumnExpendedView } from "./features/reports/CustomBusinessVolumnExpendedView";
import { CustomAverageVolumnExpendedView } from "./features/reports/CustomAverageVolumnExpendedView";
import { CurrentStatusExpendedView } from "./features/reports/CurrentStatusExpendedView";
import { FavouritesView } from './features/favourites/FavouritesView';
import { AdminView } from './features/admin/AdminView';
import { SuperAdminView } from './features/superadmin/SuperAdminView';
import Layout from './components/Layout';
import ProtectedRoutes from './components/ProtectedRoutes';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="superadmin" element={<Layout><SuperAdminView /></Layout>} />
        <Route path="/" element={<ProtectedRoutes />}>
          <Route index element={<Layout><JobView /></Layout>} />
          <Route path="admin" element={<Layout><AdminView /></Layout>} />
          <Route path="sla" element={<Layout><SlaView /></Layout>} />
          <Route path="reports" element={<Layout><ReportsView /></Layout>} />
          <Route path="sla-expended-report" element={<Layout><SlaExpendedView /></Layout>} />
          <Route path="custom-business-volumn-expended-report" element={<Layout><CustomBusinessVolumnExpendedView /></Layout>} />
          <Route path="custom-average-volumn-expended-report" element={<Layout><CustomAverageVolumnExpendedView /></Layout>} />
          <Route path="current-status-expended-report" element={<Layout><CurrentStatusExpendedView /></Layout>} />
          <Route path="favourites" element={<Layout><FavouritesView /></Layout>} />
        </Route>
      </Routes>
    </BrowserRouter>
  )
}
export default App
